"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = captialize;
/**
 * Captialize a string
 * @ignore
 * @param {string} string
 * @return {string}
 */
function captialize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
module.exports = exports["default"];
//# sourceMappingURL=captialize.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-input-range/lib/js/utils/captialize.js
// module id = 1288
// module chunks = 0